export default class Path {
    /** 根域名 */
    public static DOMAIN = "https://shop-api.xxoochina.com"

    /** Admin API 域名地址 */
    public static ADMIN = Path.DOMAIN + "/AdminAPI/"

    /** Admin API 域名地址 */
    public static WEB = Path.DOMAIN + "/WebAPI/"
}